module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp2-bdb59a6076295f3fe8a9e9e60e2172d7.jpg";